import ProductRecommendations from './product-recommendations';

export default ProductRecommendations;
